$(window).load(function () {

            /* basic - default settings */
            $('.str1').liMarquee();

            /* some custom settings */
            $('.str2').liMarquee({
                direction: 'left',
                loop: -1,
                scrolldelay: 500,
                scrollamount: 90,
                circular: false,
                hoverstop: false,
                drag: false
            });

            $('.str3').liMarquee({
                direction: 'left',
                loop: -1,
                scrolldelay: 0,
                scrollamount: 100,
                circular: true,
                drag: true
            });

            $('.str3-2').liMarquee({
                direction: 'left',
                loop: -1,
                scrolldelay: 0,
                scrollamount: 120,
                circular: true,
                drag: true
            });

            $('.str4').liMarquee({
                direction: 'up',
                loop: -1,
                scrolldelay: 0,
                scrollamount: 30,
                circular: true,
                drag: true
            });

            $('.str5').liMarquee({
                direction: 'down',
                loop: -1,
                scrolldelay: 0,
                scrollamount: 30,
                circular: true,
                drag: false
            });

            $('.str6').liMarquee({
                direction: 'up',
                loop: -1,
                scrolldelay: 0,
                scrollamount: 30,
                circular: false,
                drag: true,
                runshort: false
            });


            $('.str8').liMarquee({
                direction: 'down',
                loop: -1,
                scrolldelay: 0,
                scrollamount: 30,
                circular: false,
                drag: true
            });

            $('.str9').liMarquee({
                direction: 'right'
            });

        })

// VALIDATION START
$(document).ready(function(){
        $("#qualify_form").validate({
                debug:true,
                submitHandler: function(){
                          var form = $("#qualify_form");
                          var qualify_data = {
                              "additional_data": {
                                    "first_name": form.find('input[name="zang_fname"]').val(),
                                    "zip": form.find('input[name="zang_zip"]').val(),
                                    "age": form.find('input[name="zang_age"]').val()
                              }
                          };

                        sessionStorage.setItem('qualify_data', JSON.stringify(qualify_data));
                        $('#warningmodal').modal('show');

                },
                errorClass: "invalid",
                validClass: "valid",
                rules:{
                        zang_age:{
                                number:true
                        },
                        zang_zip: {
                                required: true,
                                minlength: 5,
                                number: true
                        }

                },
                messages:{
                        zang_fname: "Please enter First Name",
                        zang_age: {
                                required: "Please enter Age",
                                number: "Please enter valid Age"
                        },
                        zang_zip: {
                                required: "Please enter Zip",
                                minlength: "Please enter 5 digit Zip",
                                number: "Please enter valid Zip"
                        }
                }
        });
});

// Warning popup checks
$('#letmein').click(function(){
    if($('#letmein').is(':checked')){
        $('#agreeError').hide();
    } else {
        $('#agreeError').show();
    }
});

function initSwiper() {
            var screenWidth = $(window).width();
            if (screenWidth < 768 && mySwiper == undefined) {
                mySwiper = new Swiper('.want__slider_container', {
                    spaceBetween: 0,
                    freeMode: true,
                    pagination: '.swiper-pagination',
                    paginationClickable: true
                });
            } else if (screenWidth > 767 && mySwiper != undefined) {
                mySwiper.destroy();
                mySwiper = undefined;
                jQuery('.swiper-wrapper').removeAttr('style');
                jQuery('.swiper-slide').removeAttr('style');
            }
        }

        // natural slider
        var mySwiper1 = $('.natural_slider').swiper({
            mode: 'horizontal',
            loop: true,
            grabCursor: true,
            pagination: '.swiper-pagination_natural',
            paginationClickable: true
        });
        // testimonial slider
        var mySwiper1 = $('.testimonial_slider').swiper({
            mode: 'horizontal',
            loop: true,
            grabCursor: true,
            pagination: '.swiper-pagination_testimonial',
            paginationClickable: true
        });
        // scrollspy
        var offsetHeight = $("#top-nav").outerHeight();
        $('body').scrollspy({
            target: '#top-nav',
            offset: offsetHeight
        })
        // Close menu
        $(document).on('click', '.navbar-collapse.in', function (e) {
            if ($(e.target).is('a')) {
                $(this).collapse('hide');
            }
        });
        // href smooth scrolling
        $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function (event) {
                // On-page links
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {

                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - ($("#top-nav").outerHeight() - 3)
                        }, 1000, function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            };
                        });
                    }
                }
            });

$(document).ready(function () {
            var owl = $('.owl-carousel');
            owl.owlCarousel({
                items: 4,
                loop: true,
                margin: 0,
                nav: false,
                autoplay: false,
                autoplayTimeout: 800,
                autoplayHoverPause: true,
                autoplaySpeed: 760,
                responsiveClass: true,
                autoHeight: true,
                responsive: {
                    0: {
                        items: 1,
                        dots: true,
                        nav: false,
                        autoplay: false
                    },
                    600: {
                        items: 1,
                        dots: false,
                        nav: false,
                        autoplay: false
                    },
                    992: {
                        items: 2,
                        dots: false,
                        nav: false,
                        autoplay: false
                    },
                    1200: {
                        items: 3,
                        nav: false,
                        dots: false,
                        loop: true
                    },
                    1300: {
                        items: 4,
                        nav: false,
                        dots: false,
                        loop: true
                    }
                }

            });
            $('.play').on('click', function () {
                owl.trigger('play.owl.autoplay', [1000])
            })
            $('.stop').on('click', function () {
                owl.trigger('stop.owl.autoplay')
            })

        })
        // Toggle CTA on Qualify Form Visable

        function isScrolledIntoView(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();
            return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom) && (elemBottom <= docViewBottom) && (
                elemTop >= docViewTop));
        }
        $(window).scroll(function () {
            if (isScrolledIntoView($('#submit-claim'))) {
                $('#floating').slideUp();
            } else if (!isScrolledIntoView($('#submit-claim'))) {
                hideCTA = false;
                $('#floating').slideDown();
            }
        });

